<template>
  <div>
    <landlord-table />
  </div>
</template>

<script>
export default {
  components: {
    "landlord-table": () => import("@/landlord/components/LandlordDataTable.vue"),
  },
  data() {
    return {
      //
    };
  }
};
</script>
<style scoped>

</style>